import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=5a419fc8&scoped=true&"
import script from "./Unauthorized.vue?vue&type=script&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a419fc8",
  null
  
)

export default component.exports